import { instanceOf, node, object } from 'prop-types';
import React, { createContext, useContext } from 'react';
import defaultCache from './defaultCache';

const FetchContext = createContext({
  options: {},
  cache: defaultCache,
});

const FetchProvider = ({ cache = undefined, options = undefined, children }) => {
  const parentCtx = useContext(FetchContext);

  const ctx = {
    options: options || parentCtx.options || {},
    cache: cache || parentCtx.cache || defaultCache,
  };

  return <FetchContext.Provider value={ctx}>{children}</FetchContext.Provider>;
};

FetchProvider.propTypes = {
  cache: instanceOf(Map),
  options: object,
  children: node.isRequired,
};

export { FetchProvider };
export default FetchContext;
